// The category preselects the right contact-form queue.
export const BILLING_CONTACT_HREF = "/contact?category=billing";
export const ENTERPRISE_CONTACT_HREF = "/contact?category=enterprise";

export const ENTERPRISE_SELLING_POINTS = [
  "Use longer training datasets for custom voice models",
  "Improved custom voice model quality",
  "Assistance with voice training",
  "Custom number of voice slots",
  "Access to API",
];
